import { node, string } from 'prop-types'
import colorsOptions from '../stories/fundamentals/colors-styles/constants'
import { Wrapper } from './styled-components'
import { textStyleSizeOptions, textStyleWeightOptions } from '../stories/fundamentals/text-styles/constants'

function Typography({
  children,
  size = textStyleSizeOptions['TEXT-R'],
  weight = textStyleWeightOptions['TEXT-500'],
  color = colorsOptions.greys['grey-100'],
  as,
  margin,
  textalign,
  ...props
}) {
  return (
    <Wrapper
      as={as}
      size={size}
      weight={weight}
      color={color}
      margin={margin}
      textalign={textalign}
      {...props}
    >
      {children}
    </Wrapper>
  )
}

Typography.propTypes = {
  size: string,
  color: string,
  weight: string,
  children: node,
  as: string,
  margin: string,
  textalign: string
}

export default Typography
